// @flow
import React from 'react';

import { CheckBoxField } from '../../formik-utils/FormFields';
import { IS_FEDRAMP_LIVE_IN_CE1 } from '../../constants';
import { Spacer } from '../presentational/spacing/Spacer';

import { FEDRAMP_ENABLED_BACKEND_NAME, FEDRAMP_ENABLED_DISPLAY_NAME } from './constants';

// FedRAMP is chosen at creation and cannot be changed later, so it is captured in the create modal
// rather than on the estimate page.
export const FedRAMPEnabledContainer = () => {
  if (!IS_FEDRAMP_LIVE_IN_CE1) {
    return null;
  }

  return (
    <>
      <Spacer y={20} />
      <CheckBoxField
        displayCheckBoxBelowLabel={true}
        fieldDisplayName={FEDRAMP_ENABLED_DISPLAY_NAME}
        fieldName={FEDRAMP_ENABLED_BACKEND_NAME}
      />
    </>
  );
};
